/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useMemo, useState, useRef } from 'react';
import { useHistory, useParams, useLocation } from 'react-router-dom';

import { toastConstant } from 'constants/toastmessage';

import { sendInviteToUser } from 'services/messageServices';

import { viewCaseMessageDetails } from 'services/messages/messageService';

import { WebSocketConnectionContext } from 'context/WebSocketConnectionContext';
import { useToast } from 'context/ToastContext';

import { handleRedirection, openLinkInBlank, setAppTitle } from 'utils/utils';

import InviteDialogConfirmation from './components/InviteDialogConfirmation/InviteDialogConfirmation';
import InviteDialog from './components/InviteDialog/InviteDialog';
import ThreadHeading from './components/ThreadHeading/ThreadHeading';
import ConversationBetween from './components/ConversationBetween/ConversationBetween';
import CaseName from './components/CaseName/CaseName';
import MessageContainer from './components/MessageContainer/MessageContainer';
import { useSecureMessageContext } from '../Context/SecureMessageContext';
import { getClientUserList } from 'services/users/userServices';
import { UserDetailsContext } from 'context/userDetailsContext';
import GlobalLoader from 'components/GlobalLoader/GlobalLoader';
import { generateFullName } from 'utils/generateFullNameUtils';

const MessageDetails = () => {
  const history = useHistory();
  const location = useLocation();
  const { message_id } = useParams();
  const prevMessageIdRef = useRef(null);

  const { addToast } = useToast();
  const {
    isFromClientPortal,
    handleMessageStatus,
    isLeadSpecific,
    selectedMessage,
    loadFirmUserList,
    firmUserList,
    getCaseDetails,
    isGlobalMessagesScreen,
    isFromCaseSpecificModule,
  } = useSecureMessageContext();
  const websocketContext = useContext(WebSocketConnectionContext);

  const userContext = useContext(UserDetailsContext);

  const [messageDetails, setMessageDetails] = useState('');

  const [showCaseSearch, setShowCaseSearch] = useState(false);

  const [selectedCase, setSelectedCase] = useState('');
  const [caseUserClients, setCaseUserClients] = useState([]);
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);

  const [showInviteUsers, setShowInviteUsers] = useState(false);
  const [usersNotInChangedCase, setUsersNotInChangedCase] = useState([]);
  const [showSideBar, setShowSideBar] = useState(false);

  const [selectedUser, setSelectedUser] = useState([]);
  const [filteredUserList, setFilteredUserList] = useState([]);
  const [inviteInitiated, setInviteInitiated] = useState(false);
  const [usersLinkedToCaseOfSelectedMessage, setUsersLinkedToCaseOfSelectedMessage] = useState([]);

  const hasPermission = useMemo(
    () =>
      messageDetails?.accessible_list?.includes(userContext?.firmDetails?.current_user) ||
      messageDetails?.tag_in_accessible_list?.includes(userContext?.firmDetails?.current_user),
    [messageDetails?.accessible_list, messageDetails?.tag_in_accessible_list, userContext?.firmDetails?.current_user]
  );

  // Fetch message details when message_id changes (from URL pathname)
  useEffect(() => {
    if (message_id && message_id !== prevMessageIdRef.current) {
      fetchCaseMessageDetails();
      prevMessageIdRef.current = message_id;
      // Reset message details when navigating to a new message
      setMessageDetails('');
    } else if (message_id && !prevMessageIdRef.current) {
      // Initial load
      fetchCaseMessageDetails();
      prevMessageIdRef.current = message_id;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [message_id, location.pathname]);

  useEffect(() => {
    if (websocketContext.response) {
      // Check for reply in both data and body paths
      const replyData = websocketContext.response.data || websocketContext.response.body;
      if (replyData && replyData.secure_message_type === 'reply' && replyData.body) {
        if (messageDetails && messageDetails.message && replyData.body.message_thread_id === messageDetails.message_thread_id) {
          messageDetails.message.push(replyData.body);
          setMessageDetails({ ...messageDetails });
        }
        websocketContext.setResponse();
      }
    }
    if (websocketContext.secureMessageData) {
      // Check for reply in both data and body paths
      const replyData = websocketContext.secureMessageData.data || websocketContext.secureMessageData.body;
      if (replyData && replyData.secure_message_type === 'reply' && replyData.body) {
        if (messageDetails && messageDetails.message && replyData.body.message_thread_id === messageDetails.message_thread_id) {
          messageDetails.message.push(replyData.body);
          setMessageDetails({ ...messageDetails });
        }
        websocketContext.setSecureMessageData();
      }
    }
  }, [websocketContext.response, websocketContext.secureMessageData]);

  useEffect(() => {
    if (websocketContext.secureMessageError) {
      addToast(false, toastConstant.toasterType.ERROR, toastConstant.api.FAILED, toastConstant.message.MESSAGE_SEND_FAILURE);
      websocketContext.setSecureMessageError();
    }
  }, [websocketContext.secureMessageError]);

  //open link in new tab
  const redirectToPage = (e, path) => {
    e.preventDefault();
    if (!openLinkInBlank(path)) {
      history?.push(path);
    }
  };

  const checkCaseRelatedUser = (selectedUsers, usersLinkedToCaseOfSelectedMessage) => {
    let filteredUsers = selectedUsers?.filter((one) => {
      let findeditems = !usersLinkedToCaseOfSelectedMessage?.find((two) => {
        let condition;
        if (one?.client_cognito_username) {
          condition = one?.client_cognito_username === two?.client_cognito_username;
        } else {
          condition = one?.contact_id === two?.contact_id;
        }

        return condition;
      });
      return findeditems;
    });

    let filter_groups = selectedUsers.filter((item) => item?.res_type === 'user-group');

    setUsersNotInChangedCase([...filteredUsers, ...filter_groups]);
  };

  const handleInvitingUser = () => {
    try {
      let groups = [];
      let users = [];
      selectedUser.forEach((item) => {
        if (item?.res_type === 'user-group') {
          groups.push({
            group_id: item.user_group_id,
            group_name: item.group_name,
            sk: item.sk,
          });
        } else {
          users.push(item);
        }
      });

      let data = {
        invited_user: users,
        invited_group: groups,
      };
      sendInviteToUser(messageDetails?.sk, messageDetails?.is_lead, data)
        .then((response) => {
          if (response.data) {
            fetchCaseMessageDetails();

            addToast(false, toastConstant.toasterType.SUCCESS, toastConstant.api.SUCCESS, response?.data?.body);
            setSelectedUser([]);
            setFilteredUserList([]);
            setInviteInitiated(false);
            setShowConfirmDialog(false);
            setCaseUserClients([]);
          }
        })
        .catch((err) => {
          console.log('invite-error', err);

          let errorMsg = err?.response?.data ?? toastConstant.message.CASE_UPDATED_FAILED;

          addToast(false, toastConstant.toasterType.ERROR, toastConstant.api.FAILED, errorMsg);
          setSelectedCase('');
          setSelectedUser([]);
          setFilteredUserList([]);
          setShowConfirmDialog(false);
          setCaseUserClients([]);
        });
    } catch (error) {
      console.log('error', error);
    }
  };

  const fetchCaseMessageDetails = () => {
    let obj = {};
    obj.id = message_id;
    obj.pagination_token = '';
    obj.pagination_direction = 'reverse';
    obj.excludeFromLoading = false;

    viewCaseMessageDetails(obj)
      .then((response) => {
        let res = response.data;
        setMessageDetails(res);
        setShowCaseSearch(false);
        setSelectedCase('');
      })
      .catch((error) => {
        console.log(error);
        setShowCaseSearch(false);
        setSelectedCase('');
      });
  };

  const loadCaseContacts = (caseId = '', isMessageLinkedCase = false) => {
    let obj = {
      caseId: caseId,
      all_contacts: isGlobalMessagesScreen ? true : false,
      contact_id: isGlobalMessagesScreen ? userContext?.userDetails?.contact_id : false,
      is_team_member_list: isGlobalMessagesScreen ? true : false,
      is_include_groups: true,
      active_groups: true,
      excludeFromLoading: false,
    };
    getClientUserList(obj)
      .then((res) => {
        if (isMessageLinkedCase) {
          setUsersLinkedToCaseOfSelectedMessage(res.data);
        }
        setCaseUserClients(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleMarkAsUnRead = async (e, messageDetails, isRead) => {
    await handleMessageStatus(e, messageDetails, isRead, message_id);
    let url = isFromClientPortal
      ? '/client/messages'
      : isGlobalMessagesScreen
      ? '/messages'
      : `/${isLeadSpecific ? 'leads' : 'cases'}/${messageDetails?.case_id}/messages`;
    handleRedirection(history, url);
  };

  const addUserHandler = () => {
    let name = generateFullName(userContext?.userDetails);
    const {
      profile_image,
      client_cognito_username,
      is_confirmed,
      last_name,
      firm_user_id,
      access_level,
      first_name,
      status,
      calendar_color,
      email,
      pk,
    } = userContext?.userDetails || {};

    let data = {
      invited_user: [
        {
          profile_image,
          client_cognito_username,
          is_confirmed,
          last_name,
          firm_user_id,
          access_level,
          first_name,
          status,
          calendar_color,
          email,
          pk,
          recipient_name: name,
          fullName: name,
          recipient_id: client_cognito_username,
          add_my_self: true,
        },
      ],
      invited_group: [],
    };

    sendInviteToUser(messageDetails?.sk, messageDetails?.is_lead, data)
      .then((response) => {
        if (response.data) {
          fetchCaseMessageDetails();
          addToast(false, toastConstant.toasterType.SUCCESS, toastConstant.api.SUCCESS, toastConstant.message.USER_ADDED_SUCCESS);
        }
      })
      .catch((err) => {
        addToast(false, toastConstant.toasterType.ERROR, toastConstant.api.FAILED, toastConstant.message.USER_ADDED_FAILED);
      });
  };

  useEffect(() => {
    // set the app tab title
    setAppTitle('Messages', messageDetails?.subject || '');

    // clean up function
    return () => {
      setAppTitle('Messages');
    };
  }, [messageDetails]);

  return (
    <React.Fragment>
      <div className="px-2">
        <GlobalLoader />
        <ThreadHeading messageDetails={messageDetails} handleMarkAsUnRead={handleMarkAsUnRead} isFromClientPortal={isFromClientPortal} />

        {!window.location.href.includes('client') && (
          <ConversationBetween
            messageDetails={messageDetails}
            redirectToPage={redirectToPage}
            isLeadSpecific={isLeadSpecific}
            selectedMessage={selectedMessage}
            loadFirmUserList={loadFirmUserList}
            firmUserList={firmUserList}
            fetchCaseMessageDetails={fetchCaseMessageDetails}
            getCaseDetails={getCaseDetails}
            isFromCaseSpecificModule={isFromCaseSpecificModule}
          />
        )}

        {messageDetails && !isFromClientPortal && (
          <CaseName
            selectedMessage={history?.location?.state?.msg}
            {...{
              setShowSideBar,
              loadCaseContacts,
              setUsersLinkedToCaseOfSelectedMessage,
              caseUserClients,
              checkCaseRelatedUser,
              setShowInviteUsers,
              showCaseSearch,
              messageDetails,
              redirectToPage,
              selectedCase,
              setSelectedCase,
              setShowCaseSearch,
              setShowConfirmDialog,
              showSideBar,
              handleMarkAsUnRead,
              hasPermission,
              loadFirmUserList,
              firmUserList,
            }}
          />
        )}

        <MessageContainer {...{ messageDetails, showSideBar, hasPermission, addUserHandler, fetchCaseMessageDetails }} />
      </div>

      {Boolean(showConfirmDialog) && (
        <InviteDialog
          showInviteUsers={showInviteUsers}
          selectedUser={selectedUser}
          filteredUserList={filteredUserList}
          caseUserClients={caseUserClients}
          setFilteredUserList={setFilteredUserList}
          messageDetails={messageDetails}
          setSelectedUser={setSelectedUser}
          checkCaseRelatedUser={checkCaseRelatedUser}
          usersLinkedToCaseOfSelectedMessage={usersLinkedToCaseOfSelectedMessage}
          usersNotInChangedCase={usersNotInChangedCase}
          setUsersNotInChangedCase={setUsersNotInChangedCase}
          selectedCase={selectedCase}
          showConfirmDialog
          setShowConfirmDialog={setShowConfirmDialog}
          setShowInviteUsers={setShowInviteUsers}
          setInviteInitiated={setInviteInitiated}
          handleInvitingUser={handleInvitingUser}
          fetchCaseMessageDetails={fetchCaseMessageDetails}
          setSelectedCase={setSelectedCase}
        />
      )}

      <InviteDialogConfirmation
        inviteInitiated={inviteInitiated}
        setSelectedUser={setSelectedUser}
        setInviteInitiated={setInviteInitiated}
        handleInvitingUser={handleInvitingUser}
        redirectToPage={redirectToPage}
        messageDetails={messageDetails}
        usersNotInChangedCase={usersNotInChangedCase}
      />
    </React.Fragment>
  );
};

export default MessageDetails;
